export default __webpack_public_path__ + "static/media/vision.fc84847e.mp4";